type GuardedEntityCount = { key: string; label: string; count: number };

/** "82 devices · 340 interfaces" — labels come from the backend guarded-table registry. */
export const formatGuardedCounts = (
  counts: readonly GuardedEntityCount[] | undefined,
): string =>
  counts && counts.length > 0
    ? counts.map(({ count, label }) => `${count} ${label}`).join(' · ')
    : '—';
